import { lazily } from 'react-lazily'

import { Centered } from 'layout'

/**
 * password recovery
 */
const {
  PasswordRecovery,
  PasswordRecoveryRequestCode,
  AppRecoveryTokenInvalid,
  AppRecoveryTokenExpired
} = lazily(() => import('pages/password-recovery'))

const LAYOUTS = {
  centered: Centered,
}

const passwordRecoveryRoutes = [
  {
    name: 'password-recovery',
    path: 'recuperacion-de-contrasena',
    element: PasswordRecoveryRequestCode,
  },
  {
    name: 'password-recovery-2fa',
    path: 'crear-nueva-contrasena',
    element: PasswordRecovery,
  },
  {
    name: 'app-password-recovery-2fa',
    path: 'crear-nueva-contrasena-de-wallet',
    element: PasswordRecovery,
    elementProps: { isApp: true },
  },
  {
    name: 'app-password-recovery-invalid',
    path: 'recuperacion-de-contrasena-invalida',
    element: AppRecoveryTokenInvalid,
  },
  {
    name: 'app-password-recovery-expired',
    path: 'recuperacion-de-contrasena-expirado',
    element: AppRecoveryTokenExpired,
  },
]

export default passwordRecoveryRoutes
